import gsap from 'gsap'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

/* Pushmenu with automatic slides for multi-level WordPress menu's */
/* GSAP animation: the pushmenu slides in from right side of screen */

export default function initSlidingPushmenu() {
  let pushmenuActive = false; 
  let slideActive = false; 
  let prevSubnavs = [];
  let prevTitles = [];
  let curLevel = 0;

  let toggles = document.querySelectorAll('.js-toggle-pushmenu');
  let pushmenu = document.querySelector('.js-pushmenu');

  if(pushmenu) {
    let inner = pushmenu.querySelector('.js-pushmenu-inner'),
    trans = pushmenu.querySelector('.js-pushmenu-transparent'),
    links = pushmenu.getElementsByTagName('a'),
    subnav = pushmenu.querySelector('.js-pushmenu-subnav'),
    subnavTitle = pushmenu.querySelector('.js-subnav-title'),
    back = pushmenu.querySelector('.js-submenu-back'),
    slide2 = pushmenu.querySelector('.js-slide-2');

    gsap.set(pushmenu, { clearProps: "all" });
    gsap.set(inner, { clearProps: "all" });
    gsap.set(trans, { clearProps: "all" });   
    gsap.set(slide2, { clearProps: "all" }); 

    // animations
    let pushmenuIn = gsap.timeline({paused:true})
    pushmenuIn
      .to(pushmenu, {duration:0, display:"block"}, "start")
      .to(inner, {duration:0, autoAlpha:1}, "start")
      .to(trans, {duration:0.3, autoAlpha:1}, "start")
      .to(inner, {duration:0.2, x:'0px', ease: 'power1.out'}, "start+= 0.2")
      .eventCallback("onComplete",  function(){disableBodyScroll(inner); pushmenuActive = true})
      .eventCallback("onReverseComplete", function(){enableBodyScroll(inner), pushmenuActive = false; });

    let submenuIn = gsap.timeline({paused:true})
    submenuIn
    .to(inner, {duration:0, autoAlpha: 0, ease: 'power1.in'})
    .to(slide2, {duration:0.2, x:'0px', autoAlpha:1, ease: 'power1.in'})
    .eventCallback("onComplete", function(){ slideActive = true})
    .eventCallback("onReverseComplete", function(){slideActive = false});

    function hidePushmenu() {
      if(slideActive) {
        submenuIn.reverse();
        pushmenuIn.reverse();
      }
      else {
        pushmenuIn.reverse();
      }
    }

    function handleLinkClick(links) {
      [].forEach.call(links, (element) => {
        // add chevron right to links with submenu
        let submenu = element.nextElementSibling;
        if(submenu !== null) {
            if(element.lastChild.nodeName !== "I") {
              var chevron = document.createElement("i");
              chevron.classList.add("icon-chevron-right");
              element.appendChild(chevron);
            }
        }

        element.addEventListener('click', (event) => {
          let submenu = element.nextElementSibling;
  
          if(submenu !== null) { // item with submenu was clicked
            event.preventDefault();
            event.stopPropagation();

            prevTitles.push(subnavTitle.innerHTML);
            // update title of submenu
            subnavTitle.innerHTML =  "<a href='" + element + "'>" + element.innerText + "</a>"; // ?
            // add submenu links to submenu contents
            prevSubnavs.push(subnav.innerHTML);
            subnav.innerHTML = submenu.innerHTML;
            // update links to add the new sublinks
            links = subnav.getElementsByTagName('a');

            // show subnav with slide-in animation;
            submenuIn.restart();

            curLevel += 1;

            //recursive call to function on submenu links
            handleLinkClick(links);
          } else {
            console.log("swupped");
            hidePushmenu();
          }
        });
      });
    }

    // menu item is clicked
    handleLinkClick(links);

    back.addEventListener('click', (event) => {
      if(curLevel === 1) {// go back to main menu
        submenuIn.reverse();
      } else {
        submenuIn.restart();
      }
      // show previous slide
      subnavTitle.innerHTML = prevTitles.pop();
      subnav.innerHTML = prevSubnavs.pop();
      curLevel -= 1;
    });

    [].forEach.call(toggles, (element) => {
      
      element.addEventListener('click', (event) => {
        if(pushmenuActive) {// hide pushmenu (slide out)
          hidePushmenu();
        }
        else { // show pushmenu (slide in)
          pushmenuIn.restart();
        }
      });
    });
  }
}
